import * as React from 'react';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import { useProductDetailSlots } from '../../../../../slots/context.js';
import '@swc/helpers';
import '../../../../../types/product.js';
import { useSolutionsEcommContext } from '../../context/SolutionsEcommContext.js';

const SolutionsDeliveryIndicator = ()=>{
    const { Slots  } = useProductDetailSlots();
    const { activeVariant  } = useProductData();
    const { state  } = useSolutionsEcommContext();
    const { quantity  } = state.configurations;
    if (!Slots.DynamicDeliveryIndicator) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Slots.DynamicDeliveryIndicator, {
        deliveryItems: [
            {
                sku: activeVariant.sku,
                quantity
            }
        ],
        isExcludedFromCheckout: activeVariant.isExcludedFromCheckout
    });
};

export { SolutionsDeliveryIndicator };
//# sourceMappingURL=SolutionsDeliveryIndicator.js.map
